import React, { Component } from 'react';
import SetupHeader from 'src/Components/SetupHeader/SetupHeader';
import { Label, Link } from 'office-ui-fabric-react';
import { setupContent, ACCOUNT_CONSTANTS } from './SetupConstants';
import CheckBox from 'src/Components/Checkbox/Checkbox';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import PrimaryFacility from './PrimaryFacility/PrimaryFacility';
import Dropdown from 'react-dropdown';
import TextInput from 'src/Components/TextInput/TextInput';
import _ from 'lodash';
import {
  updateError,
  updateRegisterFieldValue,
  getAccountStatus
} from 'src/Actions/Registration/registerActions';
import { updateProfileDetails, getProfileDetails } from 'src/Actions/Profile/profileActions';
import { validateName } from 'src/Utils';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ProgressButton from 'src/Components/progressbutton/progressButton';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import 'react-dropdown/style.css';
import './styles.scss';
import { withTranslation } from 'react-i18next';

class SetupAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryFacilityVisible: false,
      pageViewCreated: false,
      showError: false,
      fieldErrors: null,
      acknowledge: [
        {
          id: 'News Permission',
          value: setupContent.ack1,
          isChecked: false,
          isError: false,
          isRequired: false,
        },
        {
          id: 'Contact Permission',
          value: setupContent.ack2,
          isChecked: false,
          isError: false,
          isRequired: true,
        },
        {
          id: 'Terms & Conditions and Privacy Policy',
          value: `${setupContent.ack3}`,
          isChecked: false,
          isError: false,
          isRequired: true,
        },
      ],
    };
  }

  componentDidMount() {
    const { i18n } = this.props;
    if (this.props.registration.accountStatus === null) {
      this.props.getAccountStatus();
    }
    this.props.getProfileDetails();
    i18n.on('languageChanged', () => {
      this.setAcknowledgement();
    });
  }

  setAcknowledgement = () =>{
    let itemAckList = this.state.acknowledge.slice();
      itemAckList[0].value = setupContent.ack1;
      itemAckList[1].value = setupContent.ack2;
      itemAckList[2].value = setupContent.ack3;
    this.setState({acknowledge: itemAckList})
  }

  updateAnalytics = () => {
    const category = window.location.href.replace(window.location.origin, '');
    const digitalData = {
      page: {
        pageInfo: {
          domain: document.domain,
          location: document.location,
          pageName: 'Setup Account',
          siteSection: 'Setup Account',
          pageURL: document.URL,
        },
        category: {
          primaryCategory: category.replace('/', ''),
          pageType: document.domain,
        },
        user: {
          profile: {
            profileInfo: {
              loginStatus: 'logged in',
              profileID:
                this.props.registration?.accountStatus?.userAccountSetup
                  ?.sfdcUserId,
            },
          },
        },
      },
    };

    AnalyticsService.updateDigitalData(digitalData);
    AnalyticsService.trackEvent('setAnalyticsVariables');
    AnalyticsService.trackEvent('pageLoaded');
  };

  componentDidUpdate(prevProps) {
    if (prevProps.profile !== this.props.profile) {
      let adminAccounts =
        this.props.registration &&
        this.props.registration.accountStatus?.adminAccounts;
      const { fieldValue } = this.props.registration;

      if (
        this.props.profile.updateDetails === 'SUCCESS' &&
        fieldValue?.facilityUpdated === false
      ) {
        if (adminAccounts && adminAccounts.length > 0) {
          window.location.href = window.location.origin + '/adminAcknowledge';
        } else {
          console.log(this.props.subscription.d);
          window.location.href =
            window.location.origin + this.props.subscription.d;
        }
      }
    }

    if (prevProps.registration !== this.props.registration) {
      if (
        this.props.registration?.accountStatus?.userAccountSetup &&
        !this.state.pageViewCreated
      ) {
        this.updateAnalytics();
        this.setState({ pageViewCreated: true });
      }
    }
  }

  clickIcon = (item, id, errorMessage) => {
    if (item === 'accreditingBodyId') {
      this.props.updateRegisterFieldValue({ [item]: '', ['accBodyId']: '' });
    } else {
      this.props.updateRegisterFieldValue({ [item]: '' });
    }
    if (item !== 'accBodyId' && item !== 'accreditingBodyId') {
      this.props.updateError({ [item]: errorMessage });
    }
    if (document.getElementById(id)) {
      document.getElementById(id).focus();
    }
  };

  handleChange = (type, e, item) => {
    let val = type === 'accreditingBodyType' ? e.value : item;
    if (type === 'accreditingBodyId') {
      this.props.updateRegisterFieldValue({
        [type]: val,
        ['tncCheck']: true,
        ['accBodyId']: val,
      });
    } else {
      this.props.updateRegisterFieldValue({
        [type]: val,
        ['tncCheck']: true,
      });
    }
  };

  updateInputVal = (id, errorMessage) => {
    const { fieldValue, formError } = this.props.registration;
    const { t } = this.props;

    if ((id === 'firstName' || id === 'lastName') && fieldValue[id]) {
      this.props.updateRegisterFieldValue({
        [id]: fieldValue[id].trim().replace(/\s+/g, ' '),
        ['tncCheck']: true,
      });
    }
    if (
      id === 'firstName' &&
      fieldValue['firstName']?.length === 0 &&
      !validateName(fieldValue['firstName'])
    ) {
      this.props.updateError({
        ['firstName']: t('validFirstNameError'),
      });
    } else if (
      id === 'lastName' &&
      fieldValue['lastName'] &&
      !validateName(fieldValue['lastName'])
    ) {
      this.props.updateError({ ['lastName']: t('validLastNameError') });
    } else if (
      id === 'phoneNumber' &&
      fieldValue['phoneNumber'] &&
      !fieldValue['phoneNumber'].match(
        /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/g
      )
    ) {
      this.props.updateError({ [id]: t('invalidPhoneNumberText') });
    } else if (
      id === 'phoneNumber' &&
      fieldValue['phoneNumber'] &&
      fieldValue['phoneNumber'].length < 10
    ) {
      this.props.updateError({
        [id]: t('phoneNumberMinValue'),
      });
    } else if (!fieldValue[id] || (fieldValue[id] && !fieldValue[id].trim())) {
      this.props.updateError({ [id]: errorMessage });
    } else {
      this.props.updateError({ [id]: '' });
      this.handleError(formError);
    }
  };

  handleError = (formError) => {
    if (Object.keys(formError).length > 0) {
      this.setState({
        fieldErrors: { ...formError },
      });
    } else {
      this.setState({
        showError: false,
      });
    }
  }

  handleCheckChildElement = (event) => {
    let acknowledge = this.state.acknowledge;
    const { fieldValue, formError } = this.props.registration;
    let errors = formError;
    const defaultOption = this.getDefaultAccBodyType();
    let accrBodyId;

    acknowledge.forEach((item) => {
      if (fieldValue.hasOwnProperty('accreditingBodyId')) accrBodyId = fieldValue.accreditingBodyId;
      else if (fieldValue.hasOwnProperty('accBodyId')) accrBodyId = fieldValue.accBodyId;
      else accrBodyId = '';

      if (item.id === event.target.value) {
        item.isChecked = event.target.checked;

        this.setState({
          showError: false,
        });
        if (item.isChecked) {
          item.isError = false;
        }

        delete errors[item.id];
        delete errors['accBodyId'];
        delete errors['accreditingBodyId'];
        this.props.updateError(errors);
      }
    });

    this.setState({ acknowledge: acknowledge });

    this.props.updateRegisterFieldValue({
      accreditingBodyType:
        typeof defaultOption === 'object' ? defaultOption.value : defaultOption,
      facilityUpdated: false,
      accreditingBodyId: accrBodyId
    });
  };

  changeFacility = () => {
    
    if (typeof window['digitalData'] !== 'undefined') {
      const digitalData = {
        user: {
          profile: {
            profileInfo: {
              loginStatus: 'logged in',
            },
          },
        },
      };
      AnalyticsService.updateDigitalData(digitalData);
      window.digitalData.link = {
        linkName: setupContent.linkText,
        linkType: 'Primary Facility',
      };
    }

    AnalyticsService.trackEvent('link_click');

    this.setState((prevState) => {
      return { primaryFacilityVisible: !prevState.primaryFacilityVisible };
    });
  };

  handleSubmit = () => {
    const { fieldValue, formError } = this.props.registration;
    const { t } = this.props;
    let errors = formError;
    let acknowledge = this.state.acknowledge;

    if (!fieldValue['firstName'])
      errors['firstName'] = t('enterYourFirstName');
    if (!fieldValue['lastName'])
      errors['lastName'] = t('enterYourLastName');
    if (!fieldValue['phoneNumber'])
      errors['phoneNumber'] = t('enterAPhoneNumber');

    const checkedItems = acknowledge.filter(
      (val) => val.isChecked && val.isRequired
    );
    if (checkedItems.length !== acknowledge.length) {
      acknowledge.forEach((item) => {
        if (!item.isChecked && item.isRequired) {
          const val = item.id;
          errors[val] = item.id;
          item.isError = true;
        }
      });
    }

    this.props.updateError(errors);

    if (Object.keys(formError).length > 0) {
      this.setState({
        showError: true,
        fieldErrors: { ...formError },
        acknowledge: acknowledge,
      });
    } else {
      this.setState({
        showError: false,
      });

      this.props.updateProfileDetails(fieldValue);
    }
  };

  getDefaultAccBodyType = () => {
    const { fieldValue, accreditingIdOptions } = this.props.registration;
    let defaultOption = undefined;
    if (
      !_.isEmpty(fieldValue) &&
      fieldValue.hasOwnProperty('accreditingBodyType')
    ) {
      defaultOption =
        fieldValue.accreditingBodyType === 'null' ||
        fieldValue.accreditingBodyType === ''
          ? accreditingIdOptions[0]
          : accreditingIdOptions
              .filter((x) => x.value === fieldValue.accreditingBodyType)
              .pop().value;
    } else if (
      !_.isEmpty(fieldValue) &&
      fieldValue.hasOwnProperty('accBodyType')
    ) {
      defaultOption =
        fieldValue.accBodyType &&
        fieldValue.accBodyType !== 'null' &&
        fieldValue.accBodyType.length !== 0
          ? accreditingIdOptions
              .filter((x) => x.value === fieldValue.accBodyType)
              .pop().value
          : accreditingIdOptions[0];
    }

    return defaultOption;
  };

  render() {
    let activeKey;
     if(this.state.primaryFacilityVisible) activeKey = 'facilitySelection';
     else activeKey = 'setupForm';
    const { showError, fieldErrors} = this.state;

    const { fieldValue, formError, accreditingIdOptions } = this.props.registration;
    const { isLoading } = this.props.profile;

    const defaultOption = this.getDefaultAccBodyType();
    const { t } = this.props;
    const language = this.props.profile.fieldValue.language;
    let firstNameError;
    if (formError) firstNameError = formError.firstName;
    else firstNameError = '';

    let lastNameError;
    if (formError) lastNameError = formError.lastName;
    else lastNameError = '';

    let phoneNumberError;
    if (formError) phoneNumberError = formError.phoneNumber;
    else phoneNumberError = '';

    let accreditingIdOptionsList;
    if (accreditingIdOptions) accreditingIdOptionsList = accreditingIdOptions;
    else accreditingIdOptionsList = [];

    let error;
    if(showError) error = (
      <div className="error-container">
        <span className="error-msg-items-header">
          {t('formErrorText')}
        </span>
        <br />
        <span className="errormsgItems">
          {t('setupFormErrorSubtext')} 
        </span>
        {Object.keys(fieldErrors).map((i) => {
          return (
            <div className="error-sub-value" key={i}>
              • {`${t(i)}`}
            </div>
          );
        })}
      </div>
    )
    else error = null;

    let button;
    if(isLoading) button = <ProgressButton text={t('savingAccount') + '...'} />
    else button = <PrimaryButtonGE
        text={t('submit')}
        onClick={this.handleSubmit}
        className="btn-submit"
      />
  
    return (
      <div>
        {language && <SetupHeader
          heading={ACCOUNT_CONSTANTS[activeKey].header.headingText}
          activeKey={activeKey}
          handleChangeFacilityClick={this.changeFacility}
        />}
        {language && <div className="account-body">
          <h1 className="heading">
            {ACCOUNT_CONSTANTS[activeKey].pageHeadingText}
          </h1>
          <span className="sub-header">
            {ACCOUNT_CONSTANTS[activeKey].headingHelperText}
          </span>
          <div>
            {activeKey === 'facilitySelection' ? (
              <PrimaryFacility
                ucmId={fieldValue?.parentUcmId}
                handleChangeFacilityClick={this.changeFacility}
                fieldValue={fieldValue}
              />
            ) : (
              <form className="form-container">
                <div className="section-header">
                  {setupContent.sectionIntro}
                </div>
                {error}
                <div className="account-body-wrapper">
                  <div className="wrapper-row">
                    <div className="ms-Grid-col ms-u-sm1">
                      <div className="field-label-row">
                        <Label htmlFor="firstName" className="labelText">
                          {setupContent.firstName}
                          <span className="asterisk">*</span>
                        </Label>
                        <span className="labelRequired name-required-label">
                          {setupContent.required}
                        </span>
                      </div>
                      <TextInput
                        id="first-name"
                        className="input-text"
                        placeholder={setupContent.firstName}
                        onChange={this.handleChange.bind(this, 'firstName')}
                        isSetupScreen={true}
                        inputValue={this.populateInputValue(fieldValue, 'FIRSTNAME')}
                        iconClick={this.clickIcon.bind(
                          this,
                          'firstName',
                          'first-name',
                          t('enterYourFirstName')
                        )}
                        onBlur={this.updateInputVal.bind(
                          this,
                          'firstName',
                          t('enterYourFirstName')
                        )}
                        isError={!!formError.firstName}
                        errorMessage={firstNameError}
                        isDisabled={false}
                      />
                    </div>
                    <div className="ms-Grid-col ms-u-sm1">
                      <div className="field-label-row">
                        <Label htmlFor="lastName" className="labelText">
                          {setupContent.lastName}
                          <span className="asterisk">*</span>
                        </Label>
                        <span className="labelRequired name-required-label">
                          {setupContent.required}
                        </span>
                      </div>
                      <TextInput
                        id="last-name"
                        className="input-text"
                        placeholder={setupContent.lastName}
                        onChange={this.handleChange.bind(this, 'lastName')}
                        isSetupScreen={true}
                        inputValue={this.populateInputValue(fieldValue, 'LASTNAME')}
                        iconClick={this.clickIcon.bind(
                          this,
                          'lastName',
                          'last-name',
                          t('enterYourLastName')
                        )}
                        onBlur={this.updateInputVal.bind(
                          this,
                          'lastName',
                          t('enterYourLastName')
                        )}
                        isError={!!formError.lastName}
                        errorMessage={lastNameError}
                        isDisabled={false}
                      />
                    </div>
                  </div>
                  <div className="wrapper-row">
                    <div className="ms-Grid-col ms-u-sm1 phone-number-clear-icon">
                      <div className="phone-label-row">
                        <Label htmlFor="phoneNumber" className="phoneLabel">
                          {setupContent.phoneNumber}
                          <span className="asterisk">*</span>
                        </Label>
                        <span className="labelRequired phone-label-required-margin">
                          {setupContent.required}
                        </span>
                      </div>
                      <TextInput
                        id="phone-number"
                        className="phone_Text"
                        onChange={this.handleChange.bind(this, 'phoneNumber')}
                        isSetupScreen={true}
                        placeholder="###-###-####"
                        inputValue={this.populateInputValue(fieldValue, 'PHONENUMBER')}
                        iconClick={this.clickIcon.bind(
                          this,
                          'phoneNumber',
                          'phone-number',
                          t('enterAPhoneNumber')
                        )}
                        onBlur={this.updateInputVal.bind(
                          this,
                          'phoneNumber',
                          t('enterAPhoneNumber')
                        )}
                        isError={!!formError.phoneNumber}
                        errorMessage={phoneNumberError}
                      />
                      <span className="info-msg">{setupContent.infoMsg}</span>
                    </div>
                  </div>

                  <div className="wrapper-row">
                    <div className="ms-Grid-col ms-u-sm1">
                      <div className="field-label-row">
                        <Label htmlFor="accreditingId" className="labelText">
                          {setupContent.accreditingId}
                        </Label>
                        <span className="labelRequired accid-optional-label">
                          {setupContent.optional}
                        </span>
                      </div>
                      <div className="accrediting-wrapper">
                        <Dropdown
                          id="accreditingBodyType"
                          onChange={this.handleChange.bind(
                            this,
                            'accreditingBodyType'
                          )}
                          options={accreditingIdOptionsList}
                          value={defaultOption}
                          arrowClassName="select-btn"
                        />
                        <TextInput
                          id="accreditingBodyId"
                          className="phone_Text"
                          onChange={this.handleChange.bind(
                            this,
                            'accreditingBodyId'
                          )}
                          isSetupScreen={true}
                          inputValue={this.populateInputValue(fieldValue, 'ACCBODYID')}
                          iconClick={this.clickIcon.bind(
                            this,
                            'accreditingBodyId',
                            'accreditingBodyId'
                          )}
                          onBlur={this.updateInputVal.bind(this, '', '')}
                          isError={false}
                          isRequired={false}
                          isDisabled={false}
                          placeholder={'1234'}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="facility-wrapper">
                  <div className="section-header">
                    {setupContent.sectionWork}
                  </div>
                  <div className="field-label-row">
                    <Label htmlFor="facility" className="phoneLabel">
                      {setupContent.primaryLocation}
                      <span className="asterisk">*</span>
                    </Label>
                    <span className="labelRequired primaryloc-required-label">
                      {setupContent.required}
                    </span>
                  </div>
                  <div className="facility-card">
                    {fieldValue.facilityName && <div className="facility-card-details">
                      <div>
                      <span className="facilityName">
                        {fieldValue?.facilityName}
                      </span>
                      <div className="facilityAddress">
                        {fieldValue?.street}
                      </div>
                      <div className="facilityAddress">
                        {`${fieldValue?.city}, ${fieldValue?.state}, ${fieldValue?.postalCode} ${fieldValue?.country}`}
                      </div>
                      </div>
                      <Link
                        to="/primaryFacility"
                        className="facilityLink"
                        onClick={this.changeFacility}
                      >
                        {setupContent.linkText}
                      </Link>
                    </div>}
                  </div>
                </div>
                <div className="acknowledge-wrapper">
                  <ul>
                    {this.state.acknowledge.map((acknowledge, idx) => {
                      return (
                        <CheckBox
                          isError={acknowledge.isError}
                          key={acknowledge.id}
                          handleCheckChildElement={this.handleCheckChildElement}
                          {...acknowledge}
                        />
                      );
                    })}
                  </ul>
                </div>
                {button}
              </form>
            )}
          </div>
        </div>}
      </div>
    );
  }

  populateInputValue = (inputVal, param) =>{
    switch(param){
      case 'ACCBODYID':
        return inputVal.hasOwnProperty('accBodyId')? inputVal.accBodyId : inputVal.accreditingBodyId;
      case 'PHONENUMBER':
        return inputVal?.phoneNumber ? inputVal.phoneNumber : '';
      case 'LASTNAME':
        return inputVal?.lastName ? inputVal.lastName : ''
      case 'FIRSTNAME':
        return inputVal && inputVal.firstName ? inputVal.firstName: '';
      }
    }
}

const mapStateToProps = ({
  subscription,
  registration,
  facilities,
  profile,
}) => ({ subscription, registration, facilities, profile });

const mapDispatchToProps = (dispatch) => ({
  updateError: (errorValue) => dispatch(updateError(errorValue)),
  getAccountStatus: () => dispatch(getAccountStatus()),
  updateRegisterFieldValue: (fieldValue) =>
    dispatch(updateRegisterFieldValue(fieldValue)),
    getProfileDetails: () => dispatch(getProfileDetails()),
  updateProfileDetails: (req) => dispatch(updateProfileDetails(req)),
});

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SetupAccount)));
